import { ChannelType, type ChannelTypeValue } from '@flipster/apis/v1/channel-verification/types';
import type { MessageKey } from '@flipster/i18n';
import LinkIcon from '@flipster/react/icon/generated/LinkIcon';
import MailIcon from '@flipster/react/icon/generated/MailIcon';
import TelegramIcon from '@flipster/react/icon/generated/TelegramIcon';
import TwitterIcon from '@flipster/react/icon/generated/TwitterIcon';
import WhatsappIcon from '@flipster/react/icon/generated/WhatsappIcon';

export const channelLabelKeyMap = {
  [ChannelType.Telegram]: 'VIP.r260316.Telegram_description',
  [ChannelType.Whatsapp]: 'VIP.r260316.Whatsapp_description',
  [ChannelType.X]: 'VIP.r260316.X_twitter_description',
  [ChannelType.Email]: 'VIP.r260316.Email_description',
  [ChannelType.Website]: 'VIP.r260316.Website_description',
} as const;

export const channelValues = [
  ChannelType.Telegram,
  ChannelType.Whatsapp,
  ChannelType.X,
  ChannelType.Email,
  ChannelType.Website,
] as const;

export const channelIconMap: Record<ChannelTypeValue, React.ReactNode> = {
  [ChannelType.Telegram]: <TelegramIcon size={20} />,
  [ChannelType.X]: <TwitterIcon size={20} />,
  [ChannelType.Whatsapp]: <WhatsappIcon size={20} />,
  [ChannelType.Email]: <MailIcon size={20} />,
  [ChannelType.Website]: <LinkIcon size={20} />,
};

export const channelPlaceholderMap: Record<ChannelTypeValue, string> = {
  [ChannelType.Telegram]: '@FLIPSTER_IO',
  [ChannelType.Whatsapp]: 'https://wa.me/+6594785424',
  [ChannelType.X]: '@flipster_io',
  [ChannelType.Email]: 'vip@flipster.io',
  [ChannelType.Website]: 'https://flipster.io',
};

export const channelHintKeyMap = {
  [ChannelType.Telegram]: 'VIP.r260316.Please_enter_a_username_or_a_full_url_e_g_username_or_url',
  [ChannelType.Whatsapp]: 'VIP.r260316.Please_enter_a_phone_number_or_a_full_url_e_g_number_or_url',
  [ChannelType.X]: 'VIP.r260316.Please_enter_a_handle_or_a_full_url_e_g_handle_or_url',
  [ChannelType.Email]: 'VIP.r260316.Please_enter_a_full_email_address_description',
  [ChannelType.Website]: 'VIP.r260316.Please_enter_a_full_url_description',
} as const;

export const securityTips = [
  {
    titleKey: 'VIP.r260316.How_to_secure_your_assets',
    href: 'https://flipster.io/blog/how-to-secure-your-crypto-assets',
  },
  {
    titleKey: 'VIP.r260316.Cryptocurrency_scams',
    href: 'https://flipster.io/blog/common-cryptocurrency-scams',
  },
  {
    titleKey: 'VIP.r260316.Fake_crypto_wallets',
    href: 'https://flipster.io/blog/the-truth-about-fake-crypto-wallets-in-2025',
  },
] as const;

interface FaqItem {
  questionKey: MessageKey;
  answerKeys: MessageKey[];
  hasReportLink?: boolean;
}

export const faqItems: FaqItem[] = [
  {
    questionKey: 'VIP.r260316.How_do_i_know_if_a_message_is_really_from_flipster',
    answerKeys: [
      'VIP.r260316.To_verify_whether_a_message_is_official',
      'VIP.r260316.Flipster_will_never_ask_for_your_password_otp_or_seed_phrase',
      'VIP.r260316.Flipster_will_never_request_fund_transfers_to_personal_accounts',
      'VIP.r260316.To_verify_whether_a_message_is_official_flipster_will_never_ask_for_your_passwor_description',
      'VIP.r260316.If_you_are_unsure_verify_the_contact_using_the_authenticity_check_above_before_responding',
    ],
  },
  {
    questionKey: 'VIP.r260316.What_should_i_do_if_i_receive_a_suspicious_message',
    answerKeys: [
      'VIP.r260316.If_someone_claims_to_represent_flipster_and_you_suspect_a_scam_or_phishing_attem_description',
    ],
    hasReportLink: true,
  },
];
